/**
 * @description show headings only when they have changed during the loop
 */

(function() {
	'use strict';

	angular
		.module('app')
		.directive('groupedHeadings', groupedHeadings)
        .directive('groupedHeading', groupedHeading);

	function groupedHeadings() {
		var directive = {
			restrict: 'ACE',
			scope: {},
			controller: ['$timeout', controller]
		};
		return directive;

		function controller($timeout) {
			var headings = [];
			this.addHeading = function(heading) {
				headings.push(heading);
				update();
                
				heading.$on('$destroy', function() {
					var i =  headings.indexOf(heading);
					if (i > -1) {
						headings.splice(i, 1);
					}
					update();
				});
			};
			var updatePromise;
			function update() {
				$timeout.cancel(updatePromise);
				updatePromise = $timeout(function() {
					headings.forEach(function(heading, i) {
						if (
							i === 0 ||
                            heading.groupedHeading !== headings[i-1].groupedHeading
						) {
							heading.show = true;
						} else {
							heading.show = false;
						}
					});
				});
			}
		}
	}

	function groupedHeading() {
		var directive = {
			restrict: 'E',
			require: '^^groupedHeadings',
			link: link,
			transclude: true,
			scope: {
				groupedHeading: '=key'
			},
			template: '<ng-transclude ng-if="show"></ng-transclude>'
		};
		return directive;

		function link(scope, element, attr, groupCtrl, transclude) {
			groupCtrl.addHeading(scope);
		}
	}
})();
